import merge from 'lodash/fp/merge';
import cloneDeep from 'lodash/fp/cloneDeep';
import { ResponseError } from '../../configuration/types';
import { config } from '../../config';
import { PatchedUser } from './schemas';

const authorizeFetch =
    (token: string, url = config.backend.USER_ADMIN_SERVICE, fetch = window.fetch) =>
    (path: RequestInfo, options: RequestInit) => {
        const baseUrl = url;
        const mergedOptions = merge(cloneDeep(options), {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return fetch(`${baseUrl}${path}`, mergedOptions);
    };

const reject = (response: Response) => {
    if (response.text) {
        return response.text().then((body) => {
            const error = new Error(response.statusText) as ResponseError;
            error.status = response.status;
            error.body = body;
            return Promise.reject(error);
        });
    }

    const error = new Error(response.statusText) as ResponseError;
    error.status = response.status;
    error.body = '';
    return Promise.reject(error);
};

const jsonOrReject = (response: Response) => (response.ok ? response.json() : reject(response));

export const getUser = (userId: string, token: string) => {
    const configuredFetch = authorizeFetch(token, config.backend.USER_ADMIN_SERVICE, fetch);
    return configuredFetch(`/users/${userId}`, {
        headers: {
            Accept: 'application/json',
        },
        method: 'GET',
    }).then(jsonOrReject);
};

export const patchUser = (userId: string, patchedUser: PatchedUser, token: string) => {
    const configuredFetch = authorizeFetch(token, config.backend.USER_ADMIN_SERVICE, fetch);
    return configuredFetch(`/users/${userId}`, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(patchedUser),
        method: 'PATCH',
    }).then(jsonOrReject);
};

export const userInfo = (token: string) => {
    const configuredFetch = authorizeFetch(token, config.backend.AUTHENTICATION_SERVICE, fetch);
    return configuredFetch(`/userinfo`, {
        headers: {
            Accept: 'application/json',
        },
        method: 'GET',
    }).then(jsonOrReject);
};

export const getAccounts = (token: string, profileId: string) => {
    const configuredFetch = authorizeFetch(token, config.backend.USER_ADMIN_SERVICE, fetch);

    return configuredFetch(`/users/${profileId}/accounts`, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        method: 'GET',
    });
};

export const switchAccount = (accountId: string) => {
    return fetch(`${config.login.authority}/switch-account/${accountId}`, {
        body: '',
        method: 'POST',
        credentials: 'include',
    });
};
